/* eslint-disable jira/filename-case */
export const PACKAGE_NAME = 'jiraNavigationAppsSidebarNav4Apps';
export const TEAM_NAME = 'smite';
